import React, { useEffect } from 'react';
import { Discount } from '../../../XV2';
import { useDiscount } from '../../../hooks/discount';
import moment from 'moment';
import { XRouterRedirect } from '../../x/router/redirect/XRouterRedirect';
import { useEffectOnce } from 'usehooks-ts';
import { XSDialog } from '../../../xs/component/dialog/XSDialog';
import { RootIdPage } from '../../../pages/id/RootIdPage';
import { XSIcon } from '../../../xs/component/icon/XSIcon';
import { XSSection } from '../../../xs/component/section/XSSection';
import { XSText } from '../../../xs/component/text/XSText';
import { XSBox } from '../../../xs/component/box/XSBox';

type Input = {
    discount: Discount;
    locationId: number;
    outletId?: number;
    zoneHash?: string;
};

export function TagDiscountClaim(input: Input) {
    const { discount, locationId, outletId, zoneHash } = input;
    const { claimDiscount } = useDiscount();

    useEffectOnce(() => {
        XSDialog.show(<Content {...input} />);
    });

    useEffect(() => {
        claimDiscount(discount);
    }, [discount]);

    if (zoneHash) {
        return <XRouterRedirect pageOrPath={RootIdPage} params={{ id: zoneHash }} />;
    } else if (outletId) {
        return <XRouterRedirect pageOrPath={`/location/:locationId?outletId=${outletId}`} params={{ locationId }} />;
    } else {
        return <XRouterRedirect pageOrPath={`/location/:locationId`} params={{ locationId }} />;
    }
}

function Content(input: Input) {
    const { discount } = input;

    return (
        <XSSection type={'column'} fullHeight={true}>
            <XSSection align={'center'} justify={'center'} fullWidth={true} fullHeight={true}>
                <XSSection type={'grid'} style={{ alignItems: 'center', justifyItems: 'center', gap: 24 }}>
                    <XSIcon
                        style={{
                            fontSize: 5 * 18,
                            background: 'var(--rx-color-success)',
                            borderRadius: '100%',
                            padding: 16,
                        }}>
                        percent
                    </XSIcon>

                    <XSBox type={'column'} align={'center'} gap={'sm'}>
                        <XSText color={'text-secondary'}>You have claimed discount</XSText>

                        <XSText size={'lg'}>
                            {discount.displayName || (
                                <>
                                    {discount.name} {discount.percent}%
                                </>
                            )}
                        </XSText>

                        <XSText color={'text-secondary'}>at</XSText>

                        <XSText size={'lg'}>{discount.location.name}</XSText>
                    </XSBox>

                    {discount.validTo && (
                        <XSText color={'text-secondary'}>
                            Valid until {moment(discount.validTo).format('D MMMM YYYY, HH:mm')}
                        </XSText>
                    )}
                </XSSection>
            </XSSection>

            <XSDialog.CloseButton fill={'solid'} block={true}>
                Close
            </XSDialog.CloseButton>
        </XSSection>
    );
}
